(() => {
  'use strict';

  function installMotionVisibility(page, createObserver, listen, cleanups, reducedMotion, motionAllowed) {
    if (!window.IntersectionObserver) return;
    const groups = new Map();
    page.querySelectorAll('.dh-tech-strip,.dh-hero-tour,.dh-about-tour').forEach(group => {
      const targets = [...group.querySelectorAll('.dh-marquee-track,.dh-hero-photo-backdrop,.dh-hero-store-preview,.dh-hero-store-preview img,.dh-about-store-scroll')];
      if (targets.length) groups.set(group, { visible: false, targets });
    });
    if (!groups.size) return;
    const sync = state => state.targets.forEach(target => {
      if (!state.visible || document.hidden || !motionAllowed()) {
        target.style.setProperty('animation-play-state', 'paused');
        target.style.setProperty('will-change', 'auto');
      } else {
        target.style.removeProperty('animation-play-state');
        target.style.removeProperty('will-change');
      }
    });
    const observer = createObserver(entries => entries.forEach(entry => {
      const state = groups.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      sync(state);
    }), { rootMargin: '120px 0px' });
    groups.forEach((state, group) => { sync(state); observer.observe(group); });
    listen(document, 'visibilitychange', () => groups.forEach(sync));
    listen(reducedMotion, 'change', () => groups.forEach(sync));
    cleanups.push(() => groups.forEach(state => state.targets.forEach(target => {
      target.style.removeProperty('animation-play-state');
      target.style.removeProperty('will-change');
    })));
  }

  let disposeHomeMotion;
  function installHomepageMotionVisibility() {
    disposeHomeMotion?.();
    const page = document.querySelector('#main-content.dh-page');
    if (!page || !window.IntersectionObserver) return;
    const cleanups = [];
    const listen = (target, type, callback) => {
      target.addEventListener(type, callback);
      cleanups.push(() => target.removeEventListener(type, callback));
    };
    const observe = (callback, options) => {
      const observer = new IntersectionObserver(callback, options);
      cleanups.push(() => observer.disconnect());
      return observer;
    };
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const capture = document.documentElement.hasAttribute('data-local-capture') || new URLSearchParams(window.location.search).has('capture');
    installMotionVisibility(page, observe, listen, cleanups, motion, () => !capture && !motion.matches);
    disposeHomeMotion = () => { cleanups.splice(0).reverse().forEach(cleanup => cleanup()); disposeHomeMotion = null; };
  }

  document.addEventListener('shopify:section:load', installHomepageMotionVisibility);
  document.addEventListener('shopify:section:unload', event => {
    const page = document.querySelector('#main-content.dh-page');
    if (page && event.target?.contains?.(page)) disposeHomeMotion?.();
  });
  window.addEventListener('pagehide', () => disposeHomeMotion?.());
  window.addEventListener('pageshow', installHomepageMotionVisibility);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installHomepageMotionVisibility, { once: true });
  else installHomepageMotionVisibility();
})();
